import { makeAutoObservable } from 'mobx'
import type CheckableMap from 'src/models/CheckableMap'

import type { Worksheet } from '.'

export class WorksheetColl<T extends Worksheet> {
  constructor(private workSheetMap: CheckableMap<T['id'], T>) {
    makeAutoObservable(this)
  }

  get toArr() {
    return [...this.workSheetMap.values()]
  }

  get entries() {
    return this.workSheetMap.entries()
  }

  values() {
    return this.workSheetMap.values()
  }

  set(k, v) {
    return this.workSheetMap.set(k, v)
  }

  delete(id) {
    return this.workSheetMap.delete(id)
  }

  deletes(ids) {
    return this.workSheetMap.deletes(ids)
  }

  get checkSize() {
    return this.workSheetMap.checkSize
  }

  get checkedIds() {
    return this.workSheetMap.toCheckedKeys
  }

  get isEmpty() {
    return this.workSheetMap.isEmpty
  }

  get isNotEmpty() {
    return this.workSheetMap.isNotEmpty
  }

  get toCheckedKeys() {
    return this.workSheetMap.toCheckedKeys
  }

  get toCheckedValues() {
    return this.workSheetMap.toCheckedValues
  }

  toCheckedSize() {
    return this.workSheetMap.toCheckedValues.length
  }

  get(id: T['id']) {
    return this.workSheetMap.get(id)
  }

  setCheck(v: T['id']) {
    this.workSheetMap.setCheck(v)
  }
  clearAllCheck() {
    this.workSheetMap.clearAllCheck()
  }
  isChecked(v: T['id']) {
    return this.workSheetMap.isChecked(v)
  }
  get isPartChecked() {
    return this.workSheetMap.isPartChecked
  }
  toggleCheck(v: T['id']) {
    this.workSheetMap.toggleCheck(v)
  }

  updateWorksheet(id: T['id'], updateData: T) {
    const selected = this.workSheetMap?.get(id)
    if (selected) {
      selected.update(updateData)
    }
  }

  adds(workSheetColl: WorksheetColl<T>) {
    this.workSheetMap.adds(workSheetColl.workSheetMap.entries())
  }
}
